import Vue from 'vue'
import { microservice } from 'src/app-config'

const url = api => microservice.domain + '/common' + api

const getResource = (api, token) => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url(api), {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      resolve()
      reject({
        message: 'Failed to load resource ' + api
      })
    })
  })
}

export const getHelpMenuAll = ({ userFunctionId, token }) => {
  return new Promise((resolve, reject) => {
    let headers = {'content-type': 'application/json', Authorization: 'Bearer ' + token}
    Vue.http.get(url('/help-menu2'), {
      headers: headers,
      params: {
        userFunctionId
      }
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject({
        message: 'Failed to get help menu2.'
      })
    })
  })
}

export const getHelpMenu = ({ userFunctionId, helpMenuDomain, token }) => {
  return new Promise((resolve, reject) => {
    let headers = {'content-type': 'application/json', Authorization: 'Bearer ' + token}
    Vue.http.get(url('/help-menu'), {
      headers: headers,
      params: {
        userFunctionId,
        helpMenuDomain
      }
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject({
        message: 'Failed to get help menu.'
      })
    })
  })
}

export const getBrands = (token) => {
  return getResource('/brandList', token)
}

export const getCategories = (token) => {
  return getResource('/categoryList', token)
}

export const getSubCategories = (token) => {
  return getResource('/subCategoryList', token)
}

export const getYears = (token) => {
  return getResource('/yearList', token)
}

export const getSeasons = (token) => {
  return getResource('/seasonList', token)
}

export const getMarkets = (token) => {
  return getResource('/marketList', token)
}

export const getChannels = (token) => {
  return getResource('/channelList', token)
}

export const getCountries = (token) => {
  return getResource('/countryList', token)
}

export const getDivisions = (token) => {
  return getResource('/divisionList', token)
}

export const getDepartments = (token) => {
  return getResource('/departmentList', token)
}

export const getVendors = (token) => {
  return getResource('/vendorList', token)
}

export const getMills = (token) => {
  return getResource('/millList', token)
}

export const getVendorGroups = (token) => {
  return getResource('/vendorGroupList', token)
}

export const getVendorMappingList = ({ vendorCodeList, token }) => {
  return new Promise((resolve, reject) => {
    let headers = {'content-type': 'application/json', Authorization: 'Bearer ' + token}
    Vue.http.get(url('/vendorMappingList'), {
      headers: headers,
      params: {
        vendorIdList: vendorCodeList.join(',')
      }
    }).then(response => {
      resolve(response.body)
    }).catch(response => {
      reject({
        message: 'Failed to load resource /vendorMappingList'
      })
    })
  })
}

export const getSearchPanelUserPreferences = ({ userSid, searchPanelCode, token }) => {
  return new Promise((resolve, reject) => {
    let headers = {'content-type': 'application/json', Authorization: 'Bearer ' + token}
    Vue.http.get(url('/searchPanelUserPreferences'), {
      headers: headers,
      params: {
        userSid,
        searchPanelCode
      }
    }).then(response => {
      if (response.body.userPreferenceJSON) {
        resolve(JSON.parse(response.body.userPreferenceJSON))
      } else {
        reject({
          message: 'Could not find any search panel preference for ' + searchPanelCode
        })
      }
    }).catch(response => {
      reject({
        message: 'Could not find any search panel preference of ' + searchPanelCode
      })
    })
  })
}

export const updateSearchPanelUserPreferences = ({ userSid, searchPanelCode, userPreferenceJSON, token }) => {
  return new Promise((resolve, reject) => {
    let headers = {'content-type': 'application/json', Authorization: 'Bearer ' + token}
    Vue.http.put(url('/searchPanelUserPreferences'), {
      userSid,
      searchPanelCode,
      userPreferenceJSON: JSON.stringify(userPreferenceJSON)
    }, {headers: headers}).then(resposne => {
      resolve()
    }).catch(response => {
      reject({
        message: 'Failed to update search panel preferences of ' + searchPanelCode
      })
    })
  })
}



// WEBPACK FOOTER //
// ./src/components/common/service.js